export function deviceBrowserCheck() {
  const ua = navigator.userAgent.toLowerCase();
  const platform = navigator.platform;
  const maxTouchPoints = navigator.maxTouchPoints;

  // ---- デバイス判定 ----
  const isIpad =
    /ipad/.test(ua) ||
    (platform === "MacIntel" && maxTouchPoints > 1) || // iPadOS
    (ua.includes("macintosh") && "ontouchend" in document); // 念のため
  const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);
  const isTablet = isIpad || isAndroidTablet;
  const isPortrait = window.matchMedia("(orientation: portrait)").matches;
  const isMobile =
    /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|Opera Mini/i.test(
      navigator.userAgent
    );
  const isMobileOrTablet = isMobile || isTablet;

  // ---- DOM参照 ----
  const main = document.querySelector("main");
  const body = document.body;
  if (main && body) {
    if (isTablet && isPortrait) {
      body.classList.add("is_tb_ver");
    } else {
      body.classList.remove("is_tb_ver");
    }
  }

  // ---- リスナー登録（向き・リサイズ対応）----
  const updateTabletClass = () => {
    const portrait = window.matchMedia("(orientation: portrait)").matches;
    if ((isTablet || isAndroidTablet) && portrait) {
      body.classList.add("is_tb_ver");
    } else {
      body.classList.remove("is_tb_ver");
    }
  };
  window.addEventListener("resize", updateTabletClass);
  window.addEventListener("orientationchange", updateTabletClass);

  // ---- クラス付与 ----
  if (isMobile) body.classList.add("is_mobile");
  if (navigator.userAgent.includes("Windows")) body.classList.add("is_windows");

  // ---- ブラウザ判定 ----
  if (ua.includes("msie") || ua.includes("trident")) {
    console.log("Internet Explorerをお使いですね");
  } else if (ua.includes("edg")) {
    // Edge
  } else if (ua.includes("chrome") && ua.includes("safari") && !ua.includes("edg")) {
    // Chrome
  } else if (ua.includes("safari") && !ua.includes("chrome")) {
    body.classList.add("is_safari");
  } else if (ua.includes("firefox")) {
    body.classList.add("is_ff");
  }

  // ---- 外部利用用に返す ----
  return { isMobile, isTablet, isMobileOrTablet };
}

// ✅ 他ファイルで使いたい場合
// const { isMobileOrTablet } = deviceBrowserCheck();
// if (isMobileOrTablet) { ... }
